export default __webpack_public_path__ + "static/jobbox-2-d-2151a11300edd9f5b5b325b0596468dd.webp";